import { useOutsideClick } from '../../../util/misc';

interface Option<T> {
    value: T;
    name: string;
}

interface SelectProps<T> {
    name: string;
    value: string;
    options: Option<T>[];
    onChange: (v: T | null) => void;
}

export default function Select<T>({ name, value, options, onChange }: SelectProps<T>) {
    const { dropdownRef, isOpen, setIsOpen } = useOutsideClick();

    // билд жса на сайте цепляется за ui-select, ui-select__preview и ui-select__options и ломает селект
    // заменяем их копиями с _
    return (
        <div
            ref={dropdownRef}
            className={
                '_ui-select ui-select--gray' +
                (isOpen ? ' ui-select--opened' : '') +
                (value ? ' ui-select--selected' : '')
            }
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="_ui-select__preview">
                <div className="ui-select__placeholder">{name}</div>
                <div className="ui-select__text">{value}</div>
                <div className="ui-select__icon">
                    <i className="fas fa-chevron-down" />
                </div>
            </div>
            <div className="_ui-select__options">
                <div className="scroll-content" onClick={() => onChange(null)}>
                    <div className="ui-select-option">Все</div>
                </div>
                {isOpen &&
                    options.map(({ name, value }, idx) => (
                        <div key={idx} className="scroll-content" onClick={() => onChange(value)}>
                            <div className="ui-select-option">{name}</div>
                        </div>
                    ))}
            </div>
        </div>
    );
}
